import { animate, query, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { OpendialogOfferDetailsComponent } from 'app/components/dialog/open-dialog-offer-details/opendialog-offer-details.component';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { CustomerDetails } from 'app/shared/models/class/user/user';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { ImgOfferDefaultService } from 'app/shared/services/img-offer-default/img-offer-default.service';
import { OfferService } from 'app/shared/services/offer/offer.service';
import { TooltipService } from 'app/shared/services/tooltip/tooltip.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { UsersService } from 'app/shared/services/users/users.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-admin-offers',
  templateUrl: './admin-offers.component.html',
  styleUrls: ['./admin-offers.component.scss'],
  animations: [
    trigger('change', [
      transition(':enter', [
        query('.wrap', [
          style({ opacity: 0, transform: 'translate(200px)' }),
          animate('.17s', style({ opacity: 1, transform: 'none' })),
        ])
      ]),
    ])]
})

export class AdminOffersComponent extends SubscriptionBaseComponent implements OnInit, OnDestroy {
  searchForm!: UntypedFormGroup;
  userConnected: any;
  valueInput!: string;
  isLoading = false;
  isCreationMode = false;
  isSessionMode = false;
  isFileMode = false;
  offers: FullOffer[] = [];
  offerToEdit!: FullOffer;
  offerPreview!: FullOffer;
  imageUpdate!: string;
  user!: CustomerDetails;

  constructor(
    private readonly dataService: DataService,
    private readonly cdr: ChangeDetectorRef,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly imgOfferDefault: ImgOfferDefaultService,
    private readonly dialog: MatDialog,
    private readonly route: ActivatedRoute,
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly tooltip: TooltipService,
    private readonly offerService: OfferService,
    private readonly faIconService: FaiconService,
    private readonly uiService: UiService,
    private readonly userService: UsersService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initComponent();
    this.initForm();
    this.initSub();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onEditFinished(action?: boolean): void {
    this.offerToEdit = null as any;
    this.isCreationMode = false;
    this.isSessionMode = false;
    this.isFileMode = false;
    this.offerPreview = this.offers[0];
    this.imageUpdate = null as any;

    if (action) this.getOffers();
  }

  onEdit(offer: FullOffer) {
    this.offerToEdit = offer;
    this.isCreationMode = true;
  }

  switchToSessionView(offer: FullOffer) {
    this.offerToEdit = offer;
    this.isCreationMode = false;
    this.isSessionMode = true;
  }

  switchToFilesView(offer: FullOffer) {
    this.offerToEdit = offer;
    this.isCreationMode = false;
    this.isSessionMode = false;
    this.isFileMode = true;
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  addOffer(): void {
    this.isCreationMode = true;
    this.offerPreview = null as any;
  }

  back(): void {
    const user = this.authService.getDecodedToken();

    if (user.role === 'AdminMSR') {
      this.router.navigate(['/admin/my-club']);
    } else {
      this.router.navigate(['/admin']);
    }
  }

  applyFilter(filterValue: any): void {
    this.dataService.valueInputSearchOfferAdminTable.next(filterValue);
  }

  resetSearch(): void {
    this.f.keyword.reset();
    this.dataService.valueInputSearchOfferAdminTable.next('');
  }


  openDialogOfferDetails(): void {
    // const dialogRef = this.dialog.open(OpendialogOfferDetailsComponent, {
    //   data: { offerSub: this.offer }
    // });

    // dialogRef.afterClosed().subscribe({
    //   next: () => this.tab = 'thumbnail'
    // });
  }


  getTooltip(value: string): string {
    return this.tooltip.getTooltip(value);
  }

  disabledToggle(): void {
    this.uiService.showSnackbar('Modification impossible: l\'offre est présente dans un panier ou a déjà été réservée');
  }

  private initComponent(): void {
    this.userConnected = this.authService.getDecodedToken();
    if (this.offerService.getDataOffer()) {
      const dataOffer = this.offerService.getDataOffer();
      this.offerToEdit = dataOffer.offer;
      this.isCreationMode = dataOffer.creationMode;
    }
  }

  get f() {
    return this.searchForm.controls;
  }

  private initForm(): void {
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });
  }

  private initSub(): void {

    this.subscription
      .add(
        this.dataService.valueInputSearchOfferAdminTable.subscribe({
          next: valueInput => {
            this.valueInput = valueInput;
            this.cdr.detectChanges();
          }
        })
      )

    this.isLoading = true;
    // const { club_code: userClubCode } = this.authService.getDecodedToken();

    const userKey = Number.parseInt(this.userConnected.sub);
    this.subscription.add(
      this.userService.getUserDetails(userKey).subscribe({
        next: data => {
          this.userService.setUser(data);
          this.offerService.getFullOffer(data.actorCode).subscribe({
            next: async offers => {
              this.offers = await offers.sort((a, b) => b.offerKey - a.offerKey);

              if (offers?.length) {
                this.offerPreview = this.offers[0];
              }
              this.isLoading = false;
            }
          })
        }
    })
    )

  }

  changeOfferPreview(offerPreview: FullOffer) {
    this.offerPreview = offerPreview;
  }

  getOffers(): void {
    this.isLoading = true;
    const { club_code: userClubCode } = this.authService.getDecodedToken();

    this.offerService.getFullOffer(userClubCode).subscribe({
      next: async offers => {
        this.offers = await offers.sort((a, b) => b.offerKey - a.offerKey);
        this.offerPreview = this.offers[0];

        this.isLoading = false;
      }
    });
  }


}
